module.exports = __webpack_public_path__ + "static/4-7a308e49ba6afb182fd7c216d179a267.png";